<router-outlet />

@if (loader.isLoading() || loader.pageLoading()) {
  <div class="top-loader-bar"></div>
}
